<div class="help has-text-centered mb-1" *ngIf="image$ | async as image">
    <p *ngIf="image.caption"><strong>{{ image.caption }}</strong></p>
    <p *ngIf="image.copyright">Copyright &copy; {{ image.copyright }}</p>
</div>
